import { render, staticRenderFns } from "./RequestsFilter.vue?vue&type=template&id=284954b1&"
import script from "./RequestsFilter.vue?vue&type=script&lang=js&"
export * from "./RequestsFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports